import React from 'react';

import { BaseProps } from '../../types';

import { formatCurrency } from '../../utils/formatters';
import { SMALL_PRECISION } from '@make-software/cspr-design';

export interface CurrencyProps extends BaseProps {
  amount?: string | null;
  precision?: number;
  nullLabel?: string;
  currencyLabel: string;
}

export function Currency({
  amount,
  precision = SMALL_PRECISION,
  nullLabel = 'N/A',
  currencyLabel,
}: CurrencyProps) {
  if (amount == null) {
    return <>{nullLabel}</>;
  }

  return <>{formatCurrency(amount, currencyLabel, { precision })}</>;
}

export default Currency;
